import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';

declare var bootstrap: any;

@Component({
  selector: 'app-videos-locked-popup',
  templateUrl: './videos-locked-popup.component.html',
  styleUrls: ['./videos-locked-popup.component.scss']
})
export class VideosLockedPopupComponent implements OnInit {

  user:any
  constructor(public webApi: WebapiService, private toastrService: ToastrService) {
  }

  ngOnInit()  
  {    
  } 
  
}
